
const redirectHandler = (history ,path) => {
    history.push(path);
}

export {redirectHandler} ; 